export default __webpack_public_path__ + "img/96c560c4cff501f28da1db1152d96061.svg";